import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {getBrands} from "../../actions/Products";
import {BASE_URL, IMAGE_URL} from "../../path";
import './wines.css'

function WineBrands() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [brands, setBrands] = useState<any[]>([]);
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const winesUrl = 'https://vinimark.s3.amazonaws.com/web/';
    const internalImageUrl = IMAGE_URL;

    function fetchBrands() {
        getBrands()
            .then(response => {
                setBrands(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch brands:", error);
            });
    }

    useEffect(() => {
        fetchBrands();
    }, []);

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "20%" }}>Brand</th>
                            <th style={{ width: "20%" }}>Logo</th>
                            <th style={{width: "50%"}}>Hero Image</th>
                            <th style={{width: "12%"}}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {brands.map((post) => (
                            <tr key={post.id}>
                                <td>{post.name}</td>

                                <td><img src={winesUrl + post.image_path} alt = {post.name} style={{ width: '200px' }}/></td>
                                <td>{post.hero_images.length > 0 ? <img src = {internalImageUrl + post.hero_images[0].hero_image} alt = {post.name} style={{maxHeight: '300px'}} /> : 'No Hero Image Found'}</td>
                                <td>
                                    <button
                                        className="button small"
                                        onClick={() => navigate('/dashboard/wines/brands/edit', { state: { user: user, brand: post } })}
                                        style={{ marginRight: "10px" }}
                                    >
                                        Edit Hero Image
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default WineBrands;
